module.exports = __webpack_public_path__ + "img/404-white.cf59904c.svg";